import React from 'react';
import { PageHeader } from 'antd';
import PropTypes from 'prop-types';
import { AntdTag } from '../Tag/Tag';

import styled from 'styled-components';

const mobilePageHeaderStyles = ({ isMobile }) =>
  isMobile &&
  `
.ant-page-header-heading { justify-content: center; }

.ant-page-header-heading-extra,
.ant-page-header-heading-extra .ant-space-horizontal,
.ant-page-header-heading-extra .ant-space-horizontal > *,
.ant-btn-group {
  width: 100%;
}

.ant-btn-group .ant-btn { flex: 1; }
`;

const StyledPageHeader = styled(PageHeader)`
  ${mobilePageHeaderStyles}
  .ant-tag {
    font-size: 14px;
  }
`;

const AntdPageHeader = ({
  onBack,
  title,
  subTitle,
  status,
  extra,
  footer,
  tags,
  children,
  isMobile,
  ...props
}) => {
  const tagsDisplay = tags.length ? tags : status && <AntdTag status={status}>status</AntdTag>;

  return (
    <StyledPageHeader
      ghost
      isMobile={isMobile}
      onBack={onBack}
      title={title}
      subTitle={subTitle}
      extra={extra}
      tags={tagsDisplay}
      footer={footer}
      {...props}
    >
      {children}
    </StyledPageHeader>
  );
};

AntdPageHeader.propTypes = {
  onBack: PropTypes.func,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  status: PropTypes.string,
  extra: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  footer: PropTypes.element,
  tags: PropTypes.arrayOf(PropTypes.element),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

AntdPageHeader.defaultProps = {
  subTitle: '',
  tags: [],
};

export { AntdPageHeader };
